import React from 'react';
import { Tag } from 'antd';

/**
 * Full name ("first last") of the person who reported the bug.
 * Falls back to the name stored with the report (e.g. for external users).
 *
 * @param {object} bugReport
 * @returns {string}
 */
export const bugReportReporterName = (bugReport) => {
  const person = bugReport?.person;
  const personName = [person?.first_name, person?.last_name]
    .filter(Boolean)
    .join(' ');

  return personName || bugReport?.reporter_name || '–';
};

/**
 * Full name of the person who marked the bug as resolved.
 *
 * @param {object} bugReport
 * @returns {string}
 */
export const bugReportResolverName = (bugReport) => {
  const person = bugReport?.resolved_by;

  return (
    [person?.first_name, person?.last_name].filter(Boolean).join(' ') || '–'
  );
};

/**
 * @param {object} bugReport
 * @returns {boolean}
 */
export const isBugReportResolved = (bugReport) => !!bugReport?.resolved_at;

/**
 * Status tag of the bug report.
 *
 * @param {object} bugReport
 * @param {function} t
 */
export const BugReportStateTag = ({ bugReport, t }) =>
  isBugReportResolved(bugReport) ? (
    <Tag color="green">{t('Vyriešená')}</Tag>
  ) : (
    <Tag color="orange">{t('Nevyriešená')}</Tag>
  );
